export default "__VITE_ASSET__lqsHzZIL__"